const SET_ACTIVE_TUTORIAL_PATH = "activeTutorialPath:SET_ACTIVE_TUTORIAL_PATH";

export const actionTypes = {
  SET_ACTIVE_TUTORIAL_PATH
};

const setActiveTutorialPath = tutorialPath => {
  return {
    type: SET_ACTIVE_TUTORIAL_PATH,
    tutorialPath
  };
};

export default {
  setActiveTutorialPath
};
